import { InlineButton } from "@coherehealth/common";
import { Breadcrumbs } from "@mui/material";
import { useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

type BreadcrumbLink = {
  to: string;
  label: string;
  disabled?: boolean;
};

interface QmBreadcrumpsProps {
  routes: BreadcrumbLink[];
}

const QmBreadcrumbs = ({ routes }: QmBreadcrumpsProps) => {
  const theme = useTheme();
  const numRoutes = routes.length;
  const isNotLast = (index: number) => index < numRoutes - 1;
  return (
    <Breadcrumbs>
      {routes.map((route, idx) =>
        isNotLast(idx) ? (
          <Link key={idx.toString() + route.label} to={route.to} color="inherit" style={{ textDecoration: "none" }}>
            <InlineButton disabled={route.disabled}>{route.label}</InlineButton>
          </Link>
        ) : (
          <Link key={idx.toString() + route.label} to={route.to} color="inherit" style={{ textDecoration: "none" }}>
            <InlineButton disabled style={{ color: theme.palette.text.tertiary }}>
              {route.label}
            </InlineButton>
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default QmBreadcrumbs;
